import React, { useContext, useRef, useLayoutEffect } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import Brand from '../Brand/Brand';
import Navigation, { NavigationLine } from '../Navigation/Navigation';
import { dashboardMenu, layoutMenu } from '../../menu';
import ThemeContext from '../../contexts/themeContext';
import useAsideTouch from '../../hooks/useAsideTouch';

const Aside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const { asideStyle, touchStatus, hasTouchButton, asideWidthWithSpace, x } = useAsideTouch();
	const isModernDesign = process.env.REACT_APP_MODERN_DESGIN === 'true';
	const constraintsRef = useRef(null);
	const startX = useRef(null);
	const endX = useRef(null);

	useLayoutEffect(() => {
		function handleTouchStart(e) {
			startX.current = e.touches[0].clientX;
		}

		function handleTouchEnd(e) {
			endX.current = e.changedTouches[0].clientX;
			const diffX = endX.current - startX.current;

			const isMobileOrTab = window.innerWidth <= 1200;

			if (isMobileOrTab && diffX < -80) {
				setAsideStatus(false);
			}
		}

		if (asideStatus) {
			document.addEventListener('touchstart', handleTouchStart);
			document.addEventListener('touchend', handleTouchEnd);
		}

		return () => {
			document.removeEventListener('touchstart', handleTouchStart);
			document.removeEventListener('touchend', handleTouchEnd);
		};
	}, [asideStatus, setAsideStatus]);

	return (
		<motion.aside
			style={asideStyle}
			ref={constraintsRef}
			initial={{ x: '-100%' }}
			animate={{ x: asideStatus ? 0 : '-100%' }}
			transition={{ duration: 0.1, ease: 'easeInOut' }}
			className={classNames(
				'aside',
				{ open: asideStatus },
				{
					'aside-touch-bar': hasTouchButton && isModernDesign,
					'aside-touch-bar-close': !touchStatus && hasTouchButton && isModernDesign,
					'aside-touch-bar-open': touchStatus && hasTouchButton && isModernDesign,
				},
			)}>
			<div className='aside-head'>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</div>
			<div className='aside-body'>
				<Navigation
					menu={dashboardMenu}
					id='aside-dashboard'
					asideStatus={asideStatus}
					setAsideStatus={setAsideStatus}
				/>
				<NavigationLine />
				<Navigation
					menu={layoutMenu}
					id='aside-menu'
					asideStatus={asideStatus}
					setAsideStatus={setAsideStatus}
				/>
			</div>
		</motion.aside>
	);
};

export default Aside;
